<template>
  <div v-if="shouldShowButton" class="open-in-app-container">
    <v-btn
      color="primary"
      :class="buttonClass"
      :size="xLarge ? 'x-large' : undefined"
      @click="openInApp"
    >{{ label || $t('openInApp') }}</v-btn>
  </div>
</template>

<script>
import { Capacitor } from '@capacitor/core';

export default {
  name: 'OpenInAppButton',
  props: {
    path: {
      type: String,
      required: true
    },
    buttonClass: {
      type: String,
      default: ''
    },
    xLarge: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      isAndroidBrowser: false,
      isIosBrowser: false,
      isNativePlatform: false
    }
  },
  computed: {
    isMobileBrowser() {
      return (this.isAndroidBrowser || this.isIosBrowser) && !this.isNativePlatform;
    },
    shouldShowButton() {
      return this.isMobileBrowser;
    }
  },
  mounted() {
    const userAgent = navigator.userAgent.toLowerCase();
    this.isAndroidBrowser = userAgent.includes('android');
    // iPadOS 13+ reports as "macintosh" + touch
    this.isIosBrowser = /iphone|ipad|ipod/.test(userAgent) ||
      (userAgent.includes('macintosh') && navigator.maxTouchPoints > 1);
    this.isNativePlatform = Capacitor.isNativePlatform();

    this.$emit('android-detected', this.isMobileBrowser);
  },
  methods: {
    openInApp() {
      const webUrl = `https://emcomy.app/${this.path}`;
      if (this.isAndroidBrowser) {
        // Android intent URL with web fallback
        const fallbackUrl = encodeURIComponent(webUrl);
        const intentUrl = `intent://emcomy.app/${this.path}#Intent;scheme=https;package=com.emcomy.app;S.browser_fallback_url=${fallbackUrl};end`;
        window.location.href = intentUrl;
        return;
      }
      if (this.isIosBrowser) {
        // custom scheme (triple slash => path in url.pathname), web fallback if app absent
        const schemeUrl = `com.emcomy.app:///${this.path}`;
        const fallback = setTimeout(() => { window.location.href = webUrl; }, 1200);
        window.addEventListener('pagehide', () => clearTimeout(fallback), { once: true });
        window.location.href = schemeUrl;
        return;
      }
      window.location.href = webUrl;
    }
  }
}
</script>

<style scoped>
.open-in-app-container {
  text-align: center;
  margin-top: 16px;
}
</style> 